// Dashboard Service - Sistema Santiago
import api from './api';

export const dashboardService = {
  getTasks: (filters) => api.get('/dashboard/tasks', { params: filters }),
  getTaskCounts: () => api.get('/dashboard/task-counts'),
  updateTaskStatus: (taskId, newStatus, extra = {}) => api.patch('/dashboard/tasks/status', { taskId, newStatus, ...extra }),
  getArchivedTasks: () => api.get('/dashboard/archived'),
};

export default dashboardService;